// help.page.tsx
import { useEventbriteUrl } from '@/common/constants/useEventbriteUrl';
import ContactOrganizerInfo from '@/components/ContactOrganizer/ContactOrganizerInfo/ContactOrganizerInfo';
import TextDivider from '@/components/Divider/TextDivider';
import { PageTitle } from '@/components/Layout/LeftPane/PageTitle';
import styles from '@/styles/help.module.scss';
import { Button } from '@eventbrite/marmalade';
import React from 'react';
import homeStyles from '../styles/Home.module.css';

interface HelpProps {
  isHelpPage: boolean;
  onGoBack: () => void;
}

const Help: React.FC<HelpProps> = ({ isHelpPage, onGoBack }) => {
  const HELP_CENTER_URL = useEventbriteUrl('HELP_CENTER_URL');
  const SEARCH_EVENTS_URL = useEventbriteUrl('SEARCH_EVENTS_URL');
  const handleOnBrowseHelpCenterClick = () => {
    window.open(HELP_CENTER_URL, '_blank', 'noopener,noreferrer');
  };

  const handleOnSearchEventsClick = () => {
    window.open(SEARCH_EVENTS_URL, '_blank', 'noopener,noreferrer');
  };
  return (
    <div className={styles['help-container']}>
      {isHelpPage ? (
        <>
          <PageTitle pageTitle="Help" />
        </>
      ) : (
        <>
          <PageTitle pageTitle="Contact the organizer" />
        </>
      )}
      <ContactOrganizerInfo infoText="For security reasons, Eventbrite can’t provide tickets without this information. If you" />
      {isHelpPage ? (
        <>
          <div className={styles['button-group']}>
            <Button variant="secondary" onClick={onGoBack}>
              Go back
            </Button>
            <Button variant="primary" onClick={handleOnBrowseHelpCenterClick}>
              Browse Help Center
            </Button>
          </div>
          <TextDivider text="or" />
          <Button
            variant="secondary"
            className={homeStyles['no-border-button']}
            data-testid="search-event-button-element"
            onClick={handleOnSearchEventsClick}
          >
            Search events
          </Button>
        </>
      ) : (
        <div>
          <Button
            variant="secondary"
            style={{
              width: '100%',
              textAlign: 'center',
            }}
            onClick={onGoBack}
          >
            Go back
          </Button>
        </div>
      )}
    </div>
  );
};

export default Help;
